import { render, staticRenderFns } from "./userCoursePaySuss.vue?vue&type=template&id=18101820&scoped=true"
import script from "./userCoursePaySuss.vue?vue&type=script&lang=js"
export * from "./userCoursePaySuss.vue?vue&type=script&lang=js"
import style0 from "./userCoursePaySuss.vue?vue&type=style&index=0&id=18101820&prod&lang=scss"
import style1 from "./userCoursePaySuss.vue?vue&type=style&index=1&id=18101820&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18101820",
  null
  
)

export default component.exports